<div mat-dialog-content>
  <form #inputsForm="ngForm">
    <mat-form-field>
      <mat-label>{{'RESULTS.SUMMARY.ENTER_TITLE' | anessaTranslation: trigger}}</mat-label>
      <input matInput name="saveInputs.title" [(ngModel)]="saveInputs.title" required>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'RESULTS.SUMMARY.ENTER_AUTHOR' | anessaTranslation: trigger}}</mat-label>
      <input matInput name="saveInputs.author" [(ngModel)]="saveInputs.author" required>
    </mat-form-field>
  </form>
  <div class="checkboxes">

    <ng-container *ngIf="page === 'summary'">
      <mat-checkbox *ngIf="category === 'RESULTS.SUMMARY.ALL' || category ===  'RESULTS.SUMMARY.INPUTS'"
                    [(ngModel)]="saveInputs.inputs">
        {{ 'RESULTS.SUMMARY.LIST_INPUTS' | anessaTranslation: trigger }}
      </mat-checkbox>
      <mat-checkbox *ngIf="category === 'RESULTS.SUMMARY.ALL' || category ===  'RESULTS.SUMMARY.OUTPUTS'"
                    [(ngModel)]="saveInputs.outputs">
        {{ 'RESULTS.SUMMARY.LIST_OUTPUTS' | anessaTranslation: trigger }}
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="saveInputs.cashFlow" *ngIf="showCashFlow">
        {{ 'RESULTS.SUMMARY.CASH_FLOW' | anessaTranslation: trigger }}
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="saveInputs.pfd">
        {{ 'RESULTS.SUMMARY.PFD' | anessaTranslation: trigger }}
      </mat-checkbox>
    </ng-container>

    <ng-container *ngIf="page === 'detailed'">
      <mat-checkbox *ngIf="category === 'RESULTS.SUMMARY.ALL' || category ===  'RESULTS.SUMMARY.INPUTS'"
                    [(ngModel)]="saveInputs.inputs">
        {{ 'RESULTS.SUMMARY.LIST_INPUTS' | anessaTranslation: trigger }}
      </mat-checkbox>
      <mat-checkbox *ngIf="category === 'RESULTS.SUMMARY.ALL' || category ===  'RESULTS.SUMMARY.OUTPUTS'"
                    [(ngModel)]="saveInputs.outputs">
        {{ 'RESULTS.SUMMARY.LIST_OUTPUTS' | anessaTranslation: trigger }}
      </mat-checkbox>
      <mat-checkbox *ngIf="category === 'RESULTS.SUMMARY.ALL' || category ===  'RESULTS.SUMMARY.OUTPUTS'"
                    [(ngModel)]="saveInputs.outputsYearly">
        {{ 'RESULTS.SUMMARY.OUTPUTS_YEARLY' | anessaTranslation: trigger }}
      </mat-checkbox>
    </ng-container>

  </div>

  <div class="buttons">
    <button mat-button type="submit" (click)="onSaveClick()"
            [disabled]="!inputsForm.valid || reportIsEmpty()">
      {{ 'REPORT.CREATE' | anessaTranslation: trigger }}
    </button>
    <button mat-button type="button" (click)="onCancelClick()">
      {{ 'REPORT.CANCEL' | anessaTranslation: trigger }}
    </button>
  </div>
</div>
